import { defineStore } from 'pinia';
import { ref } from '@vue/composition-api';
import { recordMark, qryMarks } from '@tencent/wphk-act-base-cgi';

// TODO 1. 统一为标准的缓存读取接口；2. key, desc形成固定模式

/**
 * 印花记录新功能气泡/红点是否已读
 */
export const useRecordNewFeatureNotice = defineStore('RecordNewFeatureNotice', () => {
  // 先标记为已读，不显示气泡(避免气泡闪现)，等查完数据之后再来决定是否展示气泡
  // 下方去决定是否要标记为未读即可，
  // 先看本地有没有标记，本地有标记的情况下，直接以本地为准，
  // 否则，在远端有mark的情况下，基于mark来判断
  const isRead = ref(true);

  const key = 'ESTAMP_RECORD_NEW_FEATURE_NOTICE_READ';
  const cache = localStorage.getItem(key);
  if (!cache) {
    qryMarks({ actId: key, offset: 0, limit: 1 })
      .then((res) => {
        const { markInfo } = res;
        if (markInfo.some(item => item.markDesc === '1')) {
          // 记录本地，下次再进时不用再请求数据
          localStorage.setItem(key, '1');
        } else {
          isRead.value = false;
        }
      })
      .catch(() => {
        isRead.value = false;
      });
  }

  const setRead = () => {
    recordMark({ actId: key, markDesc: '1' }).catch(() => {});
    localStorage.setItem(key, '1');
    isRead.value = true;
  };

  return { isRead, setRead };
});
